import React, { useMemo } from "react";
import ParkkiTheme from "themes/ParkkiTheme";
import styled from "@emotion/styled";

import StatTypes from "types/StatTypes";

import CommonUtils from "services/common/utils";
import StatsContainer from "components/StatsContainer";

const Value = styled.div`
  font-size: 21px;
  font-weight: bold;
`;

const ValueSublabel = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xsmall};
`;

const ValueLabel = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xsmall};
`;

const ValueUnity = styled.div`
  font-size: 11px;
  margin-left: 3px;
`;

const Label = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xsmall};
  width: 65%;
  text-align: center;
  color: ${ParkkiTheme.colors.darkGrey};
`;
const SubLabel = styled.div`
  padding-top: ${ParkkiTheme.spacings.tiny};
  font-size: ${ParkkiTheme.fontSizes.xsmall};
  color: ${ParkkiTheme.colors.darkGrey};
`;

type Props = { data: StatTypes; numberOfSection: number };

function MaxStats({ data, numberOfSection }: Props): JSX.Element {
  const value = useMemo(() => {
    const formattedValue =
      typeof data?.value?.formatValue === "function"
        ? data?.value?.formatValue(data?.value?.value)
        : data?.value?.value;

    if (formattedValue === null || formattedValue === undefined) {
      return "-";
    }

    return CommonUtils.formatNumber(formattedValue);
  }, [data]);

  return (
    <StatsContainer
      disabled={value === "-"}
      headerColor={data?.headerColor}
      order={data?.type?.order}
      numberOfSection={numberOfSection}
    >
      <>
        <ValueSublabel>{data?.value?.subLabel}</ValueSublabel>
        <Value>
          {value}
          <ValueUnity>{data?.type?.valueUnity}</ValueUnity>
        </Value>
        <ValueLabel>{data?.value?.label || ""}</ValueLabel>

        <SubLabel>{data?.subLabel || ""}</SubLabel>
        <Label>{data?.label}</Label>
      </>
    </StatsContainer>
  );
}

export default MaxStats;
